export default __webpack_public_path__ + "static/partner15-8d61e14550009b6738fe61abac4a3e08.jpg";